<template>
    <div class="lang-container">
        <NuxtLink
            v-for="language in locales"
            :key="language.code"
            :to="route.params?.slug ? `/${language.code}/${route.params.slug[0]}/` : `/${language.code}/`"
            :class="{ 'active': locale ===  language.code}"
        >
                {{ language.code }}
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
    const { locale, locales } = useI18n()
    const route = useRoute()
</script>